import { UPDATE_EDITOR_CONTEXT_STATE } from "state/ui/editorContext/editorContextActionTypes";

export const update = payload => {
  return {
    type: UPDATE_EDITOR_CONTEXT_STATE,
    payload
  };
};
